// Real mentor photos for the wall of faces in the account pop-up of the
// mentor chat (public/blog-mosaic-faces, about 7 KB each). Picked by hand:
// one photo a person, a face you can see.
export const MENTOR_FACES = [
  '/blog-mosaic-faces/audio-cover-13.webp',
  '/blog-mosaic-faces/new-headshot-12.webp',
  '/blog-mosaic-faces/headshot2.webp',
  '/blog-mosaic-faces/elena-vargas-headshot-photo.webp',
  '/blog-mosaic-faces/image-1.webp',
  '/blog-mosaic-faces/1762321033067.webp',
  '/blog-mosaic-faces/1000157778.webp',
  '/blog-mosaic-faces/8a340cd6-b639-475e-817a-f54b357fcb69.webp',
  '/blog-mosaic-faces/marksz-050118.webp',
  '/blog-mosaic-faces/julia-71-1.webp',
  '/blog-mosaic-faces/colorful-neon-motivational-quotes-trending-instagram-post.webp',
  '/blog-mosaic-faces/cleanshot-2026-05-20-at-10-08-07-2x.webp',
  '/blog-mosaic-faces/ammarah-ahmed.webp',
  '/blog-mosaic-faces/1621343406637.webp',
  '/blog-mosaic-faces/bunie.webp',
  '/blog-mosaic-faces/d3a3900.webp',
  '/blog-mosaic-faces/new-andrea-bergamini-profilbild-4mb-square.webp',
  '/blog-mosaic-faces/growthgal.webp',
  '/blog-mosaic-faces/ava.webp',
  '/blog-mosaic-faces/claire-schmitt-0798-web-2.webp',
  '/blog-mosaic-faces/linkedin-profile-twl.webp',
  '/blog-mosaic-faces/abdjzcrhgiga-master-enhanced.webp',
  '/blog-mosaic-faces/e66e0fff-19d5-4d98-83e1-9b4800489bcb.webp',
  '/blog-mosaic-faces/img-3768.webp',
  '/blog-mosaic-faces/1741261811505.webp',
  '/blog-mosaic-faces/ilke-april2022.webp',
  '/blog-mosaic-faces/dsc05410.webp',
  '/blog-mosaic-faces/028.webp',
  '/blog-mosaic-faces/new-img-0106.webp',
  '/blog-mosaic-faces/andy-wolfe-playa-hermosa.webp',
  '/blog-mosaic-faces/dsc02435.webp',
  '/blog-mosaic-faces/003.webp',
  '/blog-mosaic-faces/2025-09-14-13-25-29-232-0100.webp',
  '/blog-mosaic-faces/josh-boone-headshot-2025-cropped-02.webp',
  '/blog-mosaic-faces/domen-1.webp',
  '/blog-mosaic-faces/1-7.webp',
  '/blog-mosaic-faces/final-headshot-image-edited-1.webp',
  '/blog-mosaic-faces/1649946524190-1.webp',
  '/blog-mosaic-faces/2020-sesja-z-kasia1-sq.webp',
  '/blog-mosaic-faces/baptiste-profil.webp',
  '/blog-mosaic-faces/new-001-e3dro-dft1m.webp',
  '/blog-mosaic-faces/1675681697439-removebg-preview-1-copy-small.webp',
  '/blog-mosaic-faces/louis-camassa-cropped.webp',
  '/blog-mosaic-faces/headshotedited1.webp',
  '/blog-mosaic-faces/huang-roger-contributor.webp',
  '/blog-mosaic-faces/dsc8826.webp',
  '/blog-mosaic-faces/me2.webp',
  '/blog-mosaic-faces/20x30-4.webp',
  '/blog-mosaic-faces/607f00fcf7aca260d3fbc0cb-alisa-chalakhyan-400-min.webp',
  '/blog-mosaic-faces/headshot.webp',
  '/blog-mosaic-faces/eae2ab7c-289b-4ee9-8cfc-9a3552cf9951.webp',
  '/blog-mosaic-faces/new-stephen-pic.webp',
  '/blog-mosaic-faces/dsc08434-3.webp',
  '/blog-mosaic-faces/me-professional-red-use-this-one.webp',
  '/blog-mosaic-faces/group-328.webp',
  '/blog-mosaic-faces/dsc06731.webp',
]
